import React, { useContext } from 'react';
import { ChatBotContext } from '../../context/ChatBotContext';
import { useAuthStore } from '../../store/store';
import { useQuery } from '@tanstack/react-query';
import { useChatbotPrompt } from '../../hooks/useChatBotPrompt';
import { getPastSevenDaysTrendPrompts } from './prompts/userTrendPrompts';
import { getMoodStressLineData, getSatisfactionTirednessLineData } from '../../data/chartData';
import { getCheckInDataForPastSevenDays } from '../../api/dashboard';
import { moodStressOption, satisfactionTirednessOption } from '../../data/chartOptions';
import { AskWellnessBuddy } from './AskWellnessBuddy';
import ClipLoader from 'react-spinners/ClipLoader';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
);

const LineGraphsPastSevenDays = () => {
    const { updateChatBotPrompt } = useContext(ChatBotContext);

    const uid = useAuthStore(store => store.user?.uid);

    const checkInDataQuery = useQuery({
        queryKey: ['checkInForPastSevenDays', uid],
        queryFn: () => getCheckInDataForPastSevenDays(uid),
        retry: false,
        enabled: !(uid === null || uid === undefined),
    });

    const prompts = useChatbotPrompt(checkInDataQuery, getPastSevenDaysTrendPrompts(checkInDataQuery));

    if (checkInDataQuery.isLoading) {
        return (
            <div className='loading col-span-2'>
                <ClipLoader
                    loading={checkInDataQuery.isLoading}
                    size={100}
                    aria-label='Loading Spinner'
                />
            </div>
        );
    }

    if (checkInDataQuery.isError || checkInDataQuery.data === null) {
        return (
            <div className='col-span-2 mt-3 text-center'>
                <p>You have not checked in the past seven days. Check in today to review your summary next week.</p>
            </div>
        );
    }

    return (
        <>
            <div className='flex flex-column items-center'>
                <div className='h-[400px] w-full -mb-[45px] lg:mb-0 xl:mb-0'>
                    <Line
                        options={moodStressOption}
                        data={getMoodStressLineData(checkInDataQuery.data?.mood, checkInDataQuery.data?.stress)}
                        className='mb-5'
                    />
                </div>
                <AskWellnessBuddy onClick={() => updateChatBotPrompt(prompts[0])}/>
            </div>
            <div className='flex flex-column items-center'>
                <div className='h-[400px] w-full'>
                    <Line
                        options={satisfactionTirednessOption}
                        data={getSatisfactionTirednessLineData(checkInDataQuery.data?.mood, {
                            satisfaction: checkInDataQuery.data?.satisfaction,
                            tiredness: checkInDataQuery.data?.tiredness,
                        })}
                    />
                </div>
                <AskWellnessBuddy onClick={() => updateChatBotPrompt(prompts[1])}/>
            </div>
        </>
    );
};

export default LineGraphsPastSevenDays;
